import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { api, getToken, clearToken } from "@/lib/api";
import { Toaster } from "sonner";
import { LayoutDashboard, Soup, BookOpen, Activity, LogOut, Mail, Wand2, FileCode2, Image as ImageIcon, HardDrive } from "lucide-react";

export default function AdminLayout() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setMe(r.data))
      .catch(() => clearToken())
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-[hsl(var(--text-muted))]">Chargement…</div>;
  if (!me) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    clearToken();
    navigate("/admin/login", { replace: true });
  };

  const links = [
    { to: "/admin", end: true, label: "Tableau de bord", icon: LayoutDashboard },
    { to: "/admin/batch", label: "Adapter un batch", icon: Wand2 },
    { to: "/admin/import-markdown", label: "Import Markdown", icon: FileCode2 },
    { to: "/admin/recipes", label: "Recettes", icon: Soup },
    { to: "/admin/guides", label: "Guides", icon: BookOpen },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
    { to: "/admin/image-logs", label: "Logs images", icon: ImageIcon },
    { to: "/admin/migrate-images", label: "Migrer images", icon: HardDrive },
    { to: "/admin/logs", label: "Logs IA (texte)", icon: Activity },
  ];

  return (
    <div className="admin-shell flex flex-col md:flex-row">
      <aside className="admin-sidebar md:w-64 md:min-h-screen md:flex-shrink-0 p-6" data-testid="admin-sidebar">
        <a href="/" className="font-serif text-2xl text-white block mb-10">
          Recettes·Diabete
        </a>
        <nav className="space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => (isActive ? "active flex items-center gap-3" : "flex items-center gap-3")}
            >
              <l.icon className="w-4 h-4" strokeWidth={1.5} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-white/50">
          <p className="mb-2">{me.email}</p>
          <button onClick={logout} data-testid="admin-logout-btn" className="flex items-center gap-2 hover:text-white">
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 p-6 md:p-10 max-w-full overflow-x-hidden">
        <Outlet />
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
